import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {ICashboxRepository} from "@/repository/finance/cashbox/CashboxRepository.types";
import {ICashbox, ICashboxResponseType} from "@/entity/finance/cashbox/cashbox.types";
import Cashbox from "@/entity/finance/cashbox/cashbox";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {CashboxAddFormRequestType} from "@/form/finance/cashbox/CashboxAddForm.types";
import {CashboxTransferFormRequestType} from "@/form/finance/cashbox/CashboxTransferForm.types";
import qs from "qs";

export class CashboxRepository implements ICashboxRepository {
    async fetchAll(data?: PaginationRequestType): Promise<ICashbox> {
        const response = await Api.get('/finance/cashbox/get', { params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
            }});
        const responseData = response.data as ICashboxResponseType;
        return new Cashbox(responseData);
    }
    async transfer(data: CashboxTransferFormRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/finance/cashbox/transfer', data);
        return response.data;
    }
    async create(data: CashboxAddFormRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/finance/cashbox/create', data);
        return response.data;
    }
    async update(data: CashboxAddFormRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/finance/cashbox/update', data);
        return response.data;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post('/finance/cashbox/delete', data);
        return response.data;
    }
}